module.exports = __webpack_public_path__ + "img/Books.9a28073e.png";